import { Minus, Plus } from "lucide-react";

export const QtyStepper = ({ value, onChange, min = 1, testid, light = false }) => (
  <div className={`inline-flex items-center rounded-full border ${light ? "border-[#EFE6D8] bg-[#F7F2EA] text-[#1F1917]" : "border-[#2E2323] bg-[#120E0E]"}`} data-testid={testid}>
    <button type="button" onClick={() => onChange(Math.max(min, value - 1))} className="p-2.5 active:scale-90 transition-transform" data-testid={`${testid}-minus`}>
      <Minus className="w-4 h-4" />
    </button>
    <span className="w-6 text-center font-bold text-sm" data-testid={`${testid}-value`}>{value}</span>
    <button type="button" onClick={() => onChange(value + 1)} className="p-2.5 active:scale-90 transition-transform" data-testid={`${testid}-plus`}>
      <Plus className="w-4 h-4" />
    </button>
  </div>
);
